<template>
   <div class="noData">
      <div class="trainlistImg">
         <img src="/image/personal/time.png" alt="">
         <!--<p v-if="!describe"><span>暂无数据</span></p>-->
         <p><span>无相关信息</span></p>
      </div>
   </div>
</template>

<script>
export default {
   // props: ["title"],
   data() {
      return {
          // describe:true
      };
   },
   // created(){
   //   if(this.title=='运动员列表'){
   //       
   //       this.describe=true;
   //   }
   // },
};
</script>

<style lang="less" scoped>
.noData {
   .trainlistImg{
      text-align: center;
      img{
         width: 150px;
         height: 150px;
      }
   }
}
</style>
